import { get } from 'lodash';
import { connect } from 'react-redux';
import { MEMBERS_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { MEMBERS_PAGE_ID } from '@wix/communities-blog-client-common/dist/src/constants/component-ids';
import InternalLink from '../../components/link/internal-link';
import ExternalLink from '../../components/link/external-link';
import { getApplicationConfig } from '../../selectors/communities-context-selectors';
import { navigateToBlogOrPostPage, navigateToMembers } from '../navigate-to-section';

export default {
  Link: InternalLink,
  MembersLink: connect(state => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: MEMBERS_PAGE_ID,
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: '/',
  }))(ExternalLink),
  ProfileLink: connect((state, { user }) => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: MEMBERS_PAGE_ID,
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: `/${get(user, 'slug')}`,
  }))(ExternalLink),
  SettingsLink: connect((state, { user }) => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: MEMBERS_PAGE_ID,
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: `/${get(user, 'slug')}/settings`,
  }))(ExternalLink),
  NotificationsLink: connect(state => ({
    appDefinitionId: MEMBERS_APP_ID,
    sectionId: MEMBERS_PAGE_ID,
    sectionUrl: getApplicationConfig(state, MEMBERS_APP_ID).sectionUrl,
    to: `/notifications`,
  }))(ExternalLink),
  navigateToMembers: () => navigateToMembers('/'),
  navigateToProfile: user => navigateToMembers(`/${get(user, 'slug')}`),
  navigateToProfileSettings: user => navigateToMembers(`/${get(user, 'slug')}/settings`),
  navigateToNotifications: () => navigateToMembers('/notifications'),
  navigateToCreatePost: navigateToBlogOrPostPage,
  navigateToEditPost: navigateToBlogOrPostPage,
  navigateToMyDrafts: user => navigateToMembers(`/${get(user, 'slug')}/blog-drafts`),
};
